import Vue from 'vue';
import { forEach } from 'lodash';
let Toaster = /** @class */ (() => {
    class Toaster {
        ShowApiError(response) {
            let message = '';
            forEach(response.errorMessages, (item) => {
                message += item.message;
                message + '. ';
            });
            Vue.$toast.error(message, {
                timeout: 4000,
            });
        }
        ShowApiSuccess(response) {
            let message = '';
            forEach(response.successMessages, (item) => {
                message += item;
                message + '<br/>';
            });
            Vue.$toast.success(message, {
                timeout: 4000,
            });
        }
        ShowError(message) {
            Vue.$toast.error(message, {
                timeout: 4000,
            });
        }
        ShowWarning(message) {
            Vue.$toast.warning(message, {
                timeout: 4000,
            });
        }
        ShowSuccess(message) {
            Vue.$toast.success(message, {
                timeout: 4000,
            });
        }
        ShowProgress(message, title) {
            Vue.$toast.info(message, {
                timeout: 4000,
            });
        }
    }
    Toaster.vueInstance = new Vue({});
    return Toaster;
})();
export { Toaster };
export const toaster = new Toaster();
